export const SET_LAWS_DEADLINES_FETCHING = 'SET_LAWS_DEADLINES_FETCHING';
export const SET_LAWS_DEADLINES_FETCHING_ERROR = 'SET_LAWS_DEADLINES_FETCHING_ERROR';
export const SET_LAWS_DEADLINES = 'SET_LAWS_DEADLINES';
export const CLEAN_LAWS_DEADLINES = 'CLEAN_LAWS_DEADLINES';
export const ABORT_DEADLINES_REQUEST = 'ABORT_DEADLINES_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/lawsDeadlines/actions.js